export default __webpack_public_path__ + "static/media/bergen_1.266415ef.jpg";